import { createReducer } from '@ngrx/store';
import { PermanenceBuildingState } from './permanence-building.state';

export const permanenceBuildingKey = 'permanenceBuilding';
export const initialState: PermanenceBuildingState = {
  entities: {},
  residentsByBuilding: {},
};

export const PermanenceBuildingReducer = createReducer(initialState);
